import { HttpClient } from "../HttpClient";
/**
 * * Get Contents
 */
// export const GetContentsList = async ({
//   searchString,
//   userId,
//   claimStatus,
//   sortColumn = "id",
//   pageNumber = 1,
//   rowsPerPage,
//   assetLabel,
//   claimedBy = "unclaimed",
//   triggeredBy
// }) => {
//   try {
//     const { data } = await HttpClient.get("api/contents/list", {
//       params: {
//         ...(userId && { userId }),
//         pageNumber,
//         rowsPerPage,
//         assetLabel,
//         sortOrder: "desc",
//         ...(claimStatus !== undefined ? { claimStatus } : {}),
//         ...(searchString && { searchString }),
//         ...(sortColumn && { sortColumn }),
//         claimedBy,
//         triggeredBy
//       },
//     });
//     return data;
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };

export const GetContentsList = async ({
  searchString,
  userId,
  claimStatus,
  sortColumn = "id",
  pageNumber = 1,
  rowsPerPage,
  assetLabel,
  claimedBy = "unclaimed",
  triggeredBy,
  isImpersonation = false,
}) => {
  try {
    const { data } = await HttpClient.get("api/contents/list", {
      params: {
        pageNumber,
        rowsPerPage,
        assetLabel,
        sortOrder: "desc",
        claimedBy,
        triggeredBy,
        ...(searchString && { searchString }),
        ...(sortColumn && { sortColumn }),
        ...(claimStatus !== undefined ? { claimStatus } : {}),

        //Only add these when impersonating
        ...(isImpersonation && userId
          ? { userId, isImpersonation: true }
          : {}),
      },
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};